import React, { useEffect, useState } from "react";

import HttpManager from "../../../services/HttpManager";
import WappIcono from "../../../components/wappIcono";
import { errorTexto } from "./dialogos";
import { horaAmPm } from "./editor";
import { Ficha } from "./ficha";

const EDITOR: Record<string, string> = { doc: "word", docx: "word", odt: "word", xls: "cell", xlsx: "cell", csv: "cell", ppt: "slide", pptx: "slide", pdf: "pdf" };

interface Fila { id: number; node_id: number; accion: string; detalle: string | null; motivo: string | null; ip: string | null; created_at: string; archivo: string | null; ext: string; is_folder: number; space_id: number; parent_id: number | null; quien: string; }

const ACCION: Record<string, { t: string; externo?: boolean }> = {
	publico: { t: "Compartió fuera de Washington Academy", externo: true },
	publico_quitado: { t: "Quitó el enlace público", externo: true },
	abierto: { t: "Abrieron el enlace público", externo: true },
	descargado: { t: "Descargó a su computadora", externo: true },
	compartido: { t: "Compartió" },
	permiso: { t: "Cambió el permiso" },
	quitado: { t: "Quitó el acceso" },
	acceso_general: { t: "Cambió el acceso general" },
	autorizada: { t: "Autorizó compartir fuera", externo: true },
	desautorizada: { t: "Quitó el permiso de compartir fuera", externo: true },
};
export const cuandoFue = (s: string): string => {
	const d = new Date(s.includes("T") || s.endsWith("Z") ? s : s.replace(" ", "T") + "Z");
	return d.toLocaleDateString("es-MX", { day: "numeric", month: "short", year: d.getFullYear() !== new Date().getFullYear() ? "numeric" : undefined }) + ", " + horaAmPm(d);
};

/**
 * Bitácora de compartidos de WappDrive (solo Super Admin, Esteban 2026-10-09): quién compartió qué, con quién, cuándo y
 * por qué. "Fuera de Washington Academy" muestra los enlaces públicos (con su motivo) y cada vez que alguien los abrió.
 */
const Bitacora: React.FC<{ campusId: number; onAbrir: (nodeId: number, spaceId: number, parentId: number | null, isFolder: boolean) => void }> = ({ campusId, onAbrir }) => {
	const http = HttpManager.getInstance().wappdriveService;
	const [items, setItems] = useState<Fila[]>([]);
	const [total, setTotal] = useState(0);
	const [page, setPage] = useState(1);
	const [tipo, setTipo] = useState("");
	const [q, setQ] = useState("");
	const [buscar, setBuscar] = useState("");
	const [error, setError] = useState<string | null>(null);
	useEffect(() => { const t = setTimeout(() => setBuscar(q.trim()), 300); return () => clearTimeout(t); }, [q]);
	const cargar = (p: number) => http.bitacora(campusId, buscar, tipo, p).then((r) => { setItems((a) => (p === 1 ? r.data.items : [...a, ...r.data.items])); setTotal(r.data.total); setPage(p); })
		.catch((e) => setError(errorTexto(e)));
	useEffect(() => { cargar(1); }, [campusId, tipo, buscar]);

	return (
		<div className="wd-bit">
			<div className="wd-bit-barra">
				<div className="wd-pestanas" role="tablist">
					{[["", "Todo"], ["externo", "Fuera de Washington Academy"], ["interno", "Dentro"]].map(([k, l]) => <button key={k} className={tipo === k ? "on" : ""} onClick={() => setTipo(k)}>{l}</button>)}
				</div>
				<div className="wd-busca wd-bit-busca" role="search">
					<WappIcono n="search" className="wd-busca-lupa" />
					<input type="text" placeholder="Buscar archivo, persona o motivo" value={q} onChange={(e) => setQ(e.target.value)} aria-label="Buscar en la bitácora" />
					{q ? <button type="button" className="wd-busca-x" onClick={() => setQ("")} aria-label="Borrar búsqueda"><WappIcono n="x" /></button> : null}
				</div>
				<span className="wd-tenue">{total.toLocaleString("es-MX")} {total === 1 ? "movimiento" : "movimientos"}</span>
			</div>
			{error ? <div className="wd-aviso">{error}</div> : null}
			<div className="wd-tabla">
				<div className="wd-fila cab bit"><span>Cuándo</span><span>Quién</span><span>Archivo</span><span>Qué pasó</span><span>Por qué</span></div>
				{items.map((x) => {
					const a = ACCION[x.accion] || { t: x.accion };
					return (
						<div key={x.id} className={"wd-fila bit" + (a.externo ? " externo" : "")}>
							<span className="wd-tenue">{cuandoFue(x.created_at)}</span>
							<span>{x.quien || (x.accion === "abierto" ? "Alguien con el enlace" : "—")}{x.accion === "abierto" && x.ip ? <small className="wd-tenue"> · {x.ip}</small> : null}</span>
							{!x.node_id && x.accion === "descargado" ? (
								// Descarga desde otro módulo de WAPP (reporte, comprobante…): el detalle dice módulo y nombre.
								<span className="wd-nombre bit-permiso"><span className="wd-tipo"><WappIcono n="download" /></span><span className="wd-texto" title={x.detalle || ""}>{(x.detalle || "").split(" · ").slice(1).join(" · ") || "Archivo de WAPP"}</span></span>
							) : !x.node_id ? (
								// Altas y bajas de quién puede sacar archivos: no son de un archivo (node_id = 0).
								<span className="wd-nombre bit-permiso"><span className="wd-tipo"><WappIcono n="lock" /></span><span className="wd-texto" title="Permiso para compartir fuera de Washington Academy">Compartir fuera</span></span>
							) : (
								<button className="wd-nombre" onClick={() => onAbrir(x.node_id, x.space_id, x.parent_id, !!x.is_folder)} title={x.archivo || ""}>
									<Ficha n={{ is_folder: !!x.is_folder, ext: x.ext, editor: EDITOR[(x.ext || "").toLowerCase()] || null, mime: null } as any} /><span className="wd-texto">{x.archivo || "(borrado)"}</span>
								</button>
							)}
							<span className="bit-que">{a.externo ? <WappIcono n="world" /> : null}<span><b>{a.t}</b>{x.detalle ? <small>{x.detalle}</small> : null}</span></span>
							<span className={x.motivo ? "bit-motivo" : "wd-tenue"}>{x.motivo || "—"}</span>
						</div>
					);
				})}
				{!items.length ? <div className="wd-vacio">Todavía no hay movimientos.</div> : null}
			</div>
			{items.length < total ? <div className="wc-mas"><button className="wd-btn" onClick={() => cargar(page + 1)}>Ver más</button></div> : null}
		</div>
	);
};

export default Bitacora;
